var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccordionArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16667 12.8125L5 11.6459L10 6.64587L15 11.6459L13.8333 12.8125L10 8.97921L6.16667 12.8125Z",
    fill: "#76767D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionArrowUp);
export default __webpack_public_path__ + "static/media/accordion-arrow-up.819d1494ce50eee7aec217fc3c03bfef.svg";
export { ForwardRef as ReactComponent };